import { ref, reactive, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { defineStore } from "pinia";
import { createUser, changeUser } from "@/utils/services";

export const useSertStore = defineStore("sert", () => {
    const screens = {
        firstScreen: "firstScreen",
        authPhone: "authPhone",
        authSms: "authSms",
        authUserData: "authUserData",
        design: "design",
        recipient: "recipient",
        sum: "sum",
        preview: "preview",
        pay: "pay",
        checked: "checked",
        thank: "thank",
        errorPay: "errorPay",
    };

    const fields = ref({
        userName: {
            title: "",
            disabledBtn: false,
        },
        firstName: {
            title: "",
            disabledBtn: false,
        },
        lastName: {
            title: "",
            disabledBtn: false,
        },
        email: {
            title: "",
            disabledBtn: false,
        },
        phone: {
            title: "",
            disabledBtn: false,
        },
        birthday: {
            title: "",
            disabledBtn: false,
        },
        rules: {
            title: false,
            disabledBtn: false,
        },
        agreement: {
            title: false,
            disabledBtn: false,
        },
        confirmationCode: {
            title: "",
            disabledBtn: false,
        },
        message: {
            title: "",
            disabledBtn: false,
        },
        imagePath: {
            title: "",
            id: null,
            disabledBtn: false,
        },
        sum: {
            title: "",
            disabledBtn: false,
        },
        select: {
            title: "",
            id: null,
            disabledBtn: false,
        },
        physicalCertificate: {
            title: false,
            disabledBtn: false,
        },
    });
    // const defaultState = {
    //     imagePath: '',
    //     imageId: '',
    //     userName: '',
    //     message: '',
    //     sum: '',
    //     firstName: '',
    //     lastName: '',
    //     patronymic: '',
    //     birthday: '',
    //     email: '',
    //     phone: '',
    //     confirmationCode: '',
    //     physicalCertificate: false,
    //     rules: false,
    //     select: '',
    // };
    const isClient = typeof window !== "undefined";
    const normalizeHash = () => {
        if (!isClient) return screens.firstScreen;

        const hash = window.location.hash.slice(1);

        if (Object.keys(screens).includes(hash)) {
            return hash;
        }

        window.location.hash = screens.firstScreen;
        return screens.firstScreen;
    };

    // const currentScreen = ref(screens.design);
    const currentScreen = ref(normalizeHash());
    

    const goToScreen = (nameScreen) => {
        // window.location.hash = nameScreen;
        currentScreen.value = nameScreen;
    };

    const timerActive = ref(true);

    const checkedItems = ref(fields.value);
    if (isClient) {
        checkedItems.value = JSON.parse(sessionStorage.getItem("checkedItems")) || fields.value;
    }

    watch(
        checkedItems.value,
        (newValue) => {
            sessionStorage.setItem("checkedItems", JSON.stringify(newValue));
        },
        { deep: true }
    );

    const updateCheckedItem = (fieldName, fieldKey, value) => {
        if (checkedItems.value[fieldName]) {
            checkedItems.value[fieldName][fieldKey] = value;
        } else {
            console.log("updateCheckedItem:", checkedItems.value[fieldName], value);
        }
    };

    const isBtnDisabled = (keys = []) => {
        return keys.some((key) => !checkedItems.value[key]?.disabledBtn);
    };

    const remainingTime = ref({
        minutes: "00",
        secundes: "00",
    });
    let intervalId;
    const timer = () => {
        let totalSeconds = 60;
        timerActive.value = true;
        intervalId = setInterval(() => {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            remainingTime.value.minutes = String(minutes).padStart(2, "0");
            remainingTime.value.secundes = String(seconds).padStart(2, "0");

            if (totalSeconds <= 0) {
                clearInterval(intervalId);
                timerActive.value = false;
            } else {
                totalSeconds--;
            }
        }, 1000);
    };

    const resetTimer = () => {
        clearInterval(intervalId);
        timerActive.value = true;
    };

    onMounted(() => {
        window.addEventListener("hashchange", () => {
            window.location.hash = currentScreen.value;
        });
        // currentScreen.value = normalizeHash();
        
    });

    onBeforeUnmount(() => {
        window.removeEventListener("hashchange", () => {});
    });

    return {
        goToScreen,
        updateCheckedItem,
        timer,
        resetTimer,
        isBtnDisabled,

        currentScreen,
        screens,
        fields,
        checkedItems,
        timerActive,
        remainingTime,
    };
});
